import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  withStyles,
} from '@material-ui/core';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
  }
});

class LoginMicrosoft extends React.Component {
  render() {
    try {
      const url = window.location;
      const urlInstance = new URL(url);
      const storageState = localStorage.getItem('stateMs');
      const urlState = urlInstance.hash.match(/&(?:state)=([\S\s]*?)$/)[1];
      if (storageState === urlState) {
        localStorage.setItem('token', `${urlInstance.hash.match(/#(?:access_token)=([\S\s]*?)&/)[1]}`);
        localStorage.setItem('userType', 'MS');
        window.location.reload();
        return <Navigate to='/app/dashboard'/>;
      } else {
        alert('State are invalid. Please login again');
        return <Navigate to='/app/login'/>;
      }
    } catch (error) {
      alert('Something went wrong. Please login again');
      return <Navigate to='/app/login'/>;
    }
  }
}

LoginMicrosoft.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(LoginMicrosoft);
